import { FormattedMessage } from 'react-intl';

import type { CardOrdersListType } from '@/api/schema';
import TotalCard from '@/components/ui/TotalCard';

export type OrderHistorySummaryProps = {
    summary: CardOrdersListType['historySummary'];
};

const OrderHistorySummary = ({ summary }: OrderHistorySummaryProps) => (
    <div className='margin-bottom-25 margin-top-10 display-flex width-100pct gap-20'>
        <div className='panel panel-default width-25pct margin-bottom-0'>
            <TotalCard title={<FormattedMessage id='orderHistory.summary.totalOrders' />}>
                <span className='text-bold' style={{ lineHeight: 1, fontSize: '30px' }}>
                    {summary.totalOrders}
                </span>
            </TotalCard>
        </div>
        <div className='panel panel-default width-25pct margin-bottom-0'>
            <TotalCard title={<FormattedMessage id='orderHistory.summary.totalCardsOrdered' />}>
                <span className='text-bold' style={{ lineHeight: 1, fontSize: '30px' }}>
                    {summary.totalCardsOrdered}
                </span>
            </TotalCard>
        </div>
        <div className='panel panel-default width-25pct margin-bottom-0'>
            <TotalCard title={<FormattedMessage id='orderHistory.summary.totalCardsInProduction' />}>
                <span className='text-bold' style={{ lineHeight: 1, fontSize: '30px' }}>
                    {summary.totalCardsInProduction}
                </span>
            </TotalCard>
        </div>
        <div className='panel panel-default width-25pct margin-bottom-0'>
            <TotalCard title={<FormattedMessage id='orderHistory.summary.totalCardsShipped' />}>
                <span className='text-bold' style={{ lineHeight: 1, fontSize: '30px' }}>
                    {summary.totalCardsShipped}
                </span>
            </TotalCard>
        </div>
    </div>
);

export default OrderHistorySummary;
